import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CategoryOutlinedIcon from '@material-ui/icons/CategoryOutlined';
import { Box, IconButton, Typography } from '@material-ui/core';
import {
  BookmarksOutlined,
  CameraAltOutlined,
  Search,
} from '@material-ui/icons';

import { openModalPage } from 'actions/modalPage';
import { modalPages } from 'constants/modalPage';
import { displayView } from 'constants/UI';
import { setGridView, setProductGroup } from 'actions/UI';
import { GridModalTrigger } from 'containers/Forms/GridModal';
import { posSendMessage } from 'utils/hooks/useWrapper';

/**
 * The [Add product] button (line?) visible at the bottom of the bill in mobile view
 */
function ProductAddOptionButtons() {
  const dispatch = useDispatch();
  const { t } = useTranslation([
    'billTable',
    'gridButtons',
    'settingsUserInterface',
  ]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      borderTop="2px solid #cccccc"
      paddingY="2px"
    >
      <Typography>{t('functions.addProduct')}</Typography>
      <Box display="flex" gridGap="0.5rem">
        {/* wrapperInfo is expected to be set when POS is opened and to remain unchanged */
        window.wrapperInfo?.cameraScanner === true ? (
          <IconButton
            size="small"
            onClick={() => posSendMessage('scanning:cameraScan')()}
          >
            <CameraAltOutlined style={{ fontSize: '26px' }} />
          </IconButton>
        ) : null}
        <IconButton
          size="small"
          onClick={() =>
            dispatch(openModalPage({ component: modalPages.searchProducts }))
          }
        >
          <Search style={{ fontSize: '26px' }} />
        </IconButton>

        <GridModalTrigger title={t('quickSelect.title', { ns: 'gridButtons' })}>
          <IconButton
            size="small"
            onClick={() => dispatch(setGridView(displayView.quickSelect))}
          >
            <BookmarksOutlined style={{ fontSize: '26px' }} />
          </IconButton>
        </GridModalTrigger>
        <GridModalTrigger
          title={t('sections.editProductGroups', {
            ns: 'settingsUserInterface',
          })}
        >
          <IconButton
            size="small"
            onClick={() => {
              dispatch(setProductGroup('0'));
              dispatch(setGridView(displayView.productGroups));
            }}
          >
            <CategoryOutlinedIcon style={{ fontSize: '26px' }} />
          </IconButton>
        </GridModalTrigger>
      </Box>
    </Box>
  );
}

export default ProductAddOptionButtons;
